import React from 'react';
import PropTypes from 'prop-types';
import styledC from 'styled-components';
import Button from '@adsk/alloy-react-button';
import { useLocale } from '@adsk/alloy-react-locale';
const FooterActions = styledC.div.withConfig({
  displayName: "DefaultFooterActions__FooterActions",
  componentId: "sc-186tbdy-0"
})(["& > button{margin:0 10px 10px 0;}"]);
const DefaultFooterActions = _ref => {
  let {
    today
  } = _ref;
  const {
    T
  } = useLocale(_ref2 => {
    let {
      locale
    } = _ref2;
    return require("../i18n/".concat(locale, ".json"));
  });
  return /*#__PURE__*/React.createElement(FooterActions, null, /*#__PURE__*/React.createElement(Button, {
    onClick: today,
    size: Button.SIZES.SMALL
  }, T.translate('TODAY')));
};
DefaultFooterActions.displayName = 'DefaultFooterActions';
DefaultFooterActions.propTypes = {
  today: PropTypes.func.isRequired
};
export default DefaultFooterActions;
//# sourceMappingURL=DefaultFooterActions.js.map